import { render, staticRenderFns } from "./applicant_reset_dialog.vue?vue&type=template&id=15833930"
import script from "./applicant_reset_dialog.vue?vue&type=script&lang=ts"
export * from "./applicant_reset_dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports